import AbstractApiService from 'src/services/abstractApiService';
import { AUTH_URL, DOC2API_URL, api } from 'pages/APIs';

export default class TermAndConditionApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async upload(file: any): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    return super.post(
      DOC2API_URL + '/supplier/upload_terms_and_conditions',
      formData,
    );
  }
}
